import { Component, model, computed, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IToolCall } from '../../models/tool-call.model';
import { FileOperationToolViewComponent } from './file-operation-tool-view/file-operation-tool-view.component';
import { StrReplaceToolViewComponent } from './str-replace-tool-view/str-replace-tool-view.component';
import { getToolIcon, getToolTitle } from '../../utils/utils';

import { IconComponent } from 'src/app/@core/components/ui/icon/icon.component';
import { TOOLS } from 'src/app/features/general-agent/constants/tool.constants';
import { WebSearchToolViewComponent } from './web-search-tool-view/web-search-tool-view.component';
import { GenericToolViewComponent } from './generic-tool-view/generic-tool-view.component';
import { TOOL_STATUS } from '../../enums/enum';
import { SkeletonModule } from 'primeng/skeleton';
import { MultiFormatPreviewComponent } from "src/app/@shared/components/multi-format-preview/multi-format-preview.component";
import { AttachmentService } from 'src/app/contract-management/services/attachment.service';

@Component({
    selector: 'app-tool-view',
    standalone: true,
    imports: [CommonModule, SkeletonModule, FileOperationToolViewComponent, StrReplaceToolViewComponent, IconComponent,
        WebSearchToolViewComponent, GenericToolViewComponent, MultiFormatPreviewComponent],
    templateUrl: './tool-view.component.html',
    styleUrl: './tool-view.component.scss'
})
export class ToolViewComponent {
    //#region Inputs
    toolCall = model<Partial<IToolCall>>({});
    //#endregion

    //#region Private properties
    private readonly fileOperationTools = new Set([
        TOOLS.LIST_FILES,
        TOOLS.READ_FILE
    ]);

    private readonly strReplaceTools = new Set([
        TOOLS.WRITE_FILE,
        TOOLS.EDIT_FILE
    ]);

    private readonly webSearchTools = new Set([
        TOOLS.WEB_SEARCH
    ]);

    private readonly imageViewTools = new Set([
        TOOLS.VIEW_IMAGE
    ]);
    //#endregion

    //#region Computed values
    toolIcon = computed(() => getToolIcon(this.toolCall().name || ''));
    toolTitle = computed(() => getToolTitle(this.toolCall().name || ''));
    toolViewType = computed(() => {
        const toolName = this.toolCall().name as TOOLS;
        if (this.fileOperationTools.has(toolName)) {
            return 'file-operation';
        }
        if (this.strReplaceTools.has(toolName)) {
            return 'str-replace';
        }
        if (this.webSearchTools.has(toolName)) {
            return 'web-search';
        }
        if (this.imageViewTools.has(toolName)) {
            return 'view-image';
        }
        return null;
    });

    //#region Constants
    TOOLS = TOOLS;
    TOOL_STATUS = TOOL_STATUS;
    //#endregion

    //#region LUCIDE ICONS
    //#endregion

    constructor(
        private attachmentService: AttachmentService
    ) {
        effect(() => {
            this.getToolAttachmentSignedURL(this.toolCall());
        });
    }

    getToolAttachmentSignedURL(toolCall: Partial<IToolCall>): void {
        const toolName = toolCall?.name as TOOLS;
        if (toolName !== TOOLS.VIEW_IMAGE) return;

        const meta = (toolCall as any)?.response_metadata;
        if (!meta || meta?.fullUrl) return;

        const attachmentId =
            meta?.attachmentId ||
            meta?.attachment?._id ||
            meta?._id ||
            meta?.id;

        const versionId = meta?.versionId || meta?.attachment?.versionId;
        if (!attachmentId) return;

        this.attachmentService
            .getAttachmentWithSignedUrl(attachmentId, versionId)
            .subscribe({
                next: (res) => {
                    if (!res?.success || !res?.data) return;

                    this.toolCall.update((prev) => ({
                        ...prev,
                        response_metadata: {
                            ...res.data
                        }
                    }));
                },
                error: () => { }
            });
    }

}
